import { Button } from '@/components/ui/button';

/**
 * Standard dialog footer: a full-width Cancel + primary submit pair
 * (`flex gap-4`). Replaces the ~11 hand-rolled Cancel/Save footers across the
 * admin dialogs.
 *
 * Pass `onSubmit` for a click-driven button (the common case). Omit it and set
 * `submitType="submit"` when the dialog wraps a real <form>.
 */
const DialogFormFooter = ({
  onCancel,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  disabled = false,
  submitType = 'button',
  submitTestId,
}) => (
  <div className="flex gap-4 pt-4">
    <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
      {cancelLabel}
    </Button>
    <Button
      type={submitType}
      onClick={onSubmit}
      className="flex-1"
      disabled={disabled}
      data-testid={submitTestId}
    >
      {submitLabel}
    </Button>
  </div>
);

export default DialogFormFooter;
